// This file is auto-generated by @hey-api/openapi-ts

import { z } from "zod/v3";

/**
 * CompanyConfigurationSurfaceTreatment
 */
export const zCompanyConfigurationSurfaceTreatment = z.object({
  surface_treatments: z.array(z.string()),
});

/**
 * MaterialBaseFatalError
 */
export const zMaterialBaseFatalError = z.object({
  code: z.string(),
  message: z.string(),
  missingFields: z.array(z.string()).optional(),
});

/**
 * MaterialGrade
 */
export const zMaterialGrade = z.enum([
  "ALUMINIUM",
  "BRASS",
  "COPPER",
  "GALVANIZED_STEEL",
  "STAINLESS_STEEL",
  "STEEL",
  "STEEL_PRE_LACQUERED",
  "STEEL_COLD_ROLLED_CORTEN",
  "STEEL_HOT_ROLLED_CORTEN",
  "ZINC",
  "BRONZE",
  "PLASTIC",
  "CAST_IRON",
  "RUBBER",
  "MAGNESIUM",
  "TITANIUM",
  "COMPOSITE",
  "WOOD",
  "INCONEL",
  "OTHER",
]);

/**
 * MaterialMatch
 */
export const zMaterialMatch = z.object({
  materialGrade: z.string().nullish().default(null),
  materialDescription: z.string().nullish().default(null),
});

/**
 * MaterialType
 */
export const zMaterialType = z.enum([
  "SHEET",
  "ROUND_TUBE",
  "SQUARE_TUBE",
  "RECTANGULAR_TUBE",
  "ROUND_BAR",
  "SQUARE_BAR",
  "PROFILE",
  "OTHER",
]);

/**
 * PystructExtractEmailRequest
 */
export const zPystructExtractEmailRequest = z.object({
  company_material_base: z.string(),
  company_configuration_surface_treatment: zCompanyConfigurationSurfaceTreatment,
  input_file_s3_url: z.string(),
  input_file_source: z.string(),
  attachment_filenames: z.array(z.string()),
});

/**
 * PystructMaterialBaseRequest
 */
export const zPystructMaterialBaseRequest = z.object({
  inputFileS3Url: z.string(),
});

/**
 * PystructRequest
 */
export const zPystructRequest = zPystructExtractEmailRequest;

/**
 * StructInputEntry
 */
export const zStructInputEntry = z.object({
  reference_part: z.string(),
  name_file_matched: z.string(),
  quantity: z.number().int().nullish().default(null),
  material: zMaterialMatch.nullish().default(null),
  surface_treatment: z.array(z.string()).nullish().default(null),
});

/**
 * PystructExtractEmailResponse
 */
export const zPystructExtractEmailResponse = z.object({
  outputs: z.array(zStructInputEntry),
});

/**
 * PystructQueueResponse
 */
export const zPystructQueueResponse = zPystructExtractEmailResponse;

/**
 * StructuredMaterial
 */
export const zStructuredMaterial = z.object({
  type: zMaterialType,
  subType: z.string().nullish().default(null),
  name: z.string(),
  grade: zMaterialGrade,
  length: z.number(),
  width: z.number().nullish().default(null),
  height: z.number().nullish().default(null),
  tubeThickness: z.number().nullish().default(null),
  density: z.number(),
  price: z.number().int(),
});

/**
 * StructuredMaterialRow
 */
export const zStructuredMaterialRow = z.object({
  sheet: z.string().nullable(),
  sourceRow: z.number().int(),
  label: z.string().nullish().default(null),
  status: z.enum(["accepted", "needs_review", "rejected"]),
  issues: z.array(z.string()),
  material: zStructuredMaterial.nullable(),
});

/**
 * PystructMaterialBaseResponse
 */
export const zPystructMaterialBaseResponse = z.object({
  fatalError: zMaterialBaseFatalError.nullish().default(null),
  rows: z.array(zStructuredMaterialRow).optional(),
});
